var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator"},[_c('h3',{staticClass:"text-center text-muted"},[_vm._v(_vm._s(_vm.$t('misc.loading')))])])}
var staticRenderFns = []

export { render, staticRenderFns }